export const HOME_API_ROUTES = {
  BANNER_HOME: 'banner',
  CLASS_LIST: 'classList',
  SUBJECT_LIST: 'subjectList',
  TEST_SERIES_LIST: 'examList',
  HOME: 'home',
  SEARCH_SUGGESTIONS: 'search/suggetionList',
  MENU_BOARD_LIST: 'MenuBoardList',
  BOARD_DETAILS: 'testPage/boardDetails',
  VIDEO_LIST: 'dashboard/vediolist',
  VIDEO_LIST_HOME: 'home/vediolistHome',
  TESTIMONIALS_LIST: 'home/TestimonialsList',
  HOME_BOARD_LIST: 'home/HomeBoardList',
  HOME_BANNER_LIST: 'home/HomebannerList',
  HOME_CMS_LIST: 'home/CmsList',
  FAQ_LIST: 'home/FaqList'
}